import {
  AppMenuButtonProps,
  useAppMenuButtonState,
} from "../../AppFlyoutAnchor/next";

import {
  MenuButtonProps,
  useMenuButton_unstable,
} from "@fluentui/react-button";

export const useAppSplitButtonMenuButton = (
  props: AppMenuButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { disabled, icon } = props;

  // Remove ID so it doesn't get added as an attribute on the HTML button
  const { id, ...propsWithoutId } = props;
  // 'type' override here needed so that our types (e.g. "AppButtonProps") aren't assigned to the HTML element
  const state = useMenuButton_unstable(
    {
      ...propsWithoutId,
      type: "button",
      disabledFocusable: disabled,
    } as MenuButtonProps,
    ref
  );

  if (!icon) {
    // If we didn't provide an icon, don't render the slot at all
    // The MenuButton in the SplitButton should only have the menuIcon
    state.icon = undefined;
  }

  return useAppMenuButtonState(props, state);
};
